import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63467f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivable-manage receivable-list-page" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "office-loading" }, "加载中...", -1))
const _hoisted_4 = { class: "search-actions" }
const _hoisted_5 = { class: "expand-arrow" }
const _hoisted_6 = { class: "list-panel" }
const _hoisted_7 = { class: "list-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "summary-action-text"
}
const _hoisted_9 = { class: "risk-level-text" }
const _hoisted_10 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_11 = {
  key: 3,
  class: "risk-cell"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_14 = {
  key: 4,
  class: "risk-cell"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = {
  key: 0,
  class: "manual-modified-tag"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "pagination-bar" }
const _hoisted_19 = { class: "pagination-total" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import type { TableProps } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {
  queryReceivableManagePage,
  queryReceivableManageStatisticalData,
  queryReceivableManageToolbarAuth,
  RECEIVABLE_MANAGE_EXPORT_PATH,
  RECEIVABLE_MANAGE_IMPORT_PATH,
  type ReceivableManageItem,
  type ReceivableManageToolbarAuth,
} from './index';
import { querySalesOfficePage } from '../receivableCustomer';
import EditRiskDialog from './EditRiskDialog.vue';
import ViewRiskLogDialog from './ViewRiskLogDialog.vue';
import ExportDialog from './ExportDialog.vue';
import ImportDialog from './ImportDialog.vue';
import SendMailDialog from '../receivableCustomer/SendMailDialog.vue';
import { useResizableColumns } from '../tableColumnResize';

export default /*#__PURE__*/_defineComponent({
  __name: 'receivableManage',
  props: {
    onClose: null
  },
  setup(__props: any) {



/** 分页中文文案：15条/页、跳至 等 */
const paginationLocale = zhCN.Pagination;

/** 财务大区：value 传后端，label 展示 */
const financeAreaOptions = [
  { value: 'EAST', label: '东区' },
  { value: 'WEST', label: '西区' },
  { value: 'SOUTH', label: '南区' },
  { value: 'NORTH', label: '北区' },
];

const riskLevelOptions = [
  { value: '待人工确认', label: '待人工确认' },
  { value: '低', label: '低' },
  { value: '中', label: '中' },
  { value: '高', label: '高' },
];

/** 是/否：下拉用字符串，请求时转 boolean（避免 select 对 false 处理异常） */
const yesNoOptions = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

function toOptionalBoolean(value?: string) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

/** 渠道：展示文案，传 10/20 */
const channelOptions = [
  { value: '10', label: '10渠道' },
  { value: '20', label: '20渠道' },
];

const searchForm = reactive({
  financeArea: undefined as string | undefined,
  companyCode: undefined as string | undefined,
  financeOwner: '',
  customerCode: '',
  salesman: '',
  dissaleChannelCode: undefined as string | undefined,
  riskLevel: undefined as string | undefined,
  controlUserCode: '',
  hasControlUser: undefined as string | undefined,
  isProsecute: undefined as string | undefined,
  isOverdue: undefined as string | undefined,
});

/** 搜索栏默认收起，仅展示前 3 项 */
const searchExpanded = ref(false);
/** 收起/展开均为每行 3 项；收起时整行由 CSS 与按钮区均分 1:1:1:1 */
const searchColSpan = 8;

function toggleSearchExpand() {
  searchExpanded.value = !searchExpanded.value;
  // 展开/收起后等 DOM 落稳再算高度，避免仍用旧的 table-area 高度
  nextTick(() => {
    requestAnimationFrame(() => updateTableScrollY());
  });
}

const loading = ref(false);
const dataSource = ref<ReceivableManageItem[]>([]);
const selectedRowKeys = ref<string[]>([]);
/** 勾选行 masterId（导出用；列表不展示） */
const selectedMasterIds = ref<string[]>([]);
const tableAreaRef = ref<HTMLElement | null>(null);
/** 换数后强制重建表格，避免 fixed+scroll 留下幽灵行 */
const tableRenderKey = ref(0);

/** 行高固定 36（对齐设计器）；空间不够时出表内竖向滚动，绝不缩小行高/文字 */
const TABLE_ROW_HEIGHT = 36;
const TABLE_HEADER_HEIGHT = 36;
const TABLE_SCROLLBAR_SIZE = 17;
const TABLE_BODY_FALLBACK =
  TABLE_ROW_HEIGHT * 8 + TABLE_SCROLLBAR_SIZE;
const tableScrollY = ref<number | undefined>(undefined);
const tableAreaMaxHeight = ref<number | undefined>(undefined);
const tableBodyYScroll = ref(false);

const {
  columns,
  scrollX,
  handleResizeColumn,
} = useResizableColumns([
  { title: '客户编码', dataIndex: 'customerCode', key: 'customerCode', width: 75, ellipsis: true, fixed: 'left' },
  { title: '客户名称', dataIndex: 'customerName', key: 'customerName', width: 180, ellipsis: true, fixed: 'left' },
  { title: '分公司', dataIndex: 'companyName', key: 'companyName', width: 90, ellipsis: true, fixed: 'left' },
  { title: '付款条件', dataIndex: 'paymentTerm', key: 'paymentTerm', width: 100, ellipsis: true, fixed: 'left' },
  { title: '应收账款余额', dataIndex: 'receivableBalance', key: 'receivableBalance', width: 100, ellipsis: true, fixed: 'left' },
  { title: '信用期内', dataIndex: 'creditWithin', key: 'creditWithin', width: 100, ellipsis: true, fixed: 'left' },
  { title: '逾期金额小计', dataIndex: 'overdueTotal', key: 'overdueTotal', width: 100, ellipsis: true, fixed: 'left' },
  { title: '逾期1月', dataIndex: 'overdue1', key: 'overdue1', width: 90, ellipsis: true },
  { title: '逾期2月', dataIndex: 'overdue2', key: 'overdue2', width: 90, ellipsis: true },
  { title: '逾期3月', dataIndex: 'overdue3', key: 'overdue3', width: 90, ellipsis: true },
  { title: '逾期4月', dataIndex: 'overdue4', key: 'overdue4', width: 90, ellipsis: true },
  { title: '逾期5月', dataIndex: 'overdue5', key: 'overdue5', width: 90, ellipsis: true },
  { title: '逾期6月', dataIndex: 'overdue6', key: 'overdue6', width: 90, ellipsis: true },
  { title: '逾期7月', dataIndex: 'overdue7', key: 'overdue7', width: 90, ellipsis: true },
  { title: '逾期8月', dataIndex: 'overdue8', key: 'overdue8', width: 90, ellipsis: true },
  { title: '逾期9月', dataIndex: 'overdue9', key: 'overdue9', width: 90, ellipsis: true },
  { title: '逾期10月', dataIndex: 'overdue10', key: 'overdue10', width: 100, ellipsis: true },
  { title: '逾期11月', dataIndex: 'overdue11', key: 'overdue11', width: 100, ellipsis: true },
  { title: '逾期12月', dataIndex: 'overdue12', key: 'overdue12', width: 100, ellipsis: true },
  { title: '逾期超1年', dataIndex: 'overdueOverYear', key: 'overdueOverYear', width: 100, ellipsis: true },
  {
    title: '风险等级',
    dataIndex: 'riskLevel',
    key: 'riskLevel',
    width: 140,
    customCell: (record: ReceivableManageItem) => {
      if (record.isSummaryRow) return {};
      if (record.riskLevel === '高') return { class: 'risk-level-high' };
      if (record.riskLevel === '中') return { class: 'risk-level-mid' };
      return {};
    },
  },
  { title: '风险等级原因', dataIndex: 'riskReason', key: 'riskReason', width: 180, ellipsis: true },
  { title: '逾期原因及说明', dataIndex: 'overdueReason', key: 'overdueReason', width: 200, ellipsis: true },
  { title: '逾期原因(业务反馈)', dataIndex: 'latestFeedback', key: 'latestFeedback', width: 200, ellipsis: true },
  { title: '是否专业客户', dataIndex: 'isProfessional', key: 'isProfessional', width: 110, ellipsis: true },
  { title: '财务大区', dataIndex: 'financeArea', key: 'financeArea', width: 90, ellipsis: true },
  { title: '公司', dataIndex: 'corpCode', key: 'corpCode', width: 100, ellipsis: true },
  { title: '销售渠道', dataIndex: 'saleChannelName', key: 'saleChannelName', width: 120, ellipsis: true },
  { title: '渠道', dataIndex: 'channel', key: 'channel', width: 100, ellipsis: true },
  { title: '同一控制人', dataIndex: 'controller', key: 'controller', width: 110, ellipsis: true },
  { title: '是否起诉客户', dataIndex: 'isProsecute', key: 'isProsecute', width: 110, ellipsis: true },
  { title: '分支财务', dataIndex: 'financeOwner', key: 'financeOwner', width: 110, ellipsis: true },
  { title: '分支财务工号', dataIndex: 'financeOwnerNo', key: 'financeOwnerNo', width: 130, ellipsis: true },
  { title: '业务员', dataIndex: 'salesman', key: 'salesman', width: 100, ellipsis: true },
  { title: '业务员工号', dataIndex: 'salesmanNo', key: 'salesmanNo', width: 120, ellipsis: true },
  { title: '分公司经理', dataIndex: 'companyManager', key: 'companyManager', width: 110, ellipsis: true },
  { title: '分公司经理工号', dataIndex: 'companyManagerNo', key: 'companyManagerNo', width: 130, ellipsis: true },
  { title: '数据同步时间', dataIndex: 'syncAt', key: 'syncAt', width: 160, ellipsis: true },
  { title: '操作', key: 'action', width: 160 },
]);

const tableScroll = computed(() => {
  if (tableScrollY.value == null) {
    return { x: scrollX.value };
  }
  return { x: scrollX.value, y: tableScrollY.value };
});

/** 表体高度 CSS 变量：空数据时也撑满，横向滚动条贴底 */
const tableAreaStyle = computed(() => {
  const style: Record<string, string> = {};
  if (tableAreaMaxHeight.value != null) {
    style.maxHeight = `${tableAreaMaxHeight.value}px`;
  }
  if (tableScrollY.value != null) {
    style['--receivable-table-body-h'] = `${tableScrollY.value}px`;
  }
  style['--rc-row-height'] = `${TABLE_ROW_HEIGHT}px`;
  style['--rc-header-height'] = `${TABLE_HEADER_HEIGHT}px`;
  return style;
});

const pageSizeOptions = ['10', '15', '30', '50', '100', '200'];

const pagination = reactive({
  current: 1,
  pageSize: 15,
  total: 0,
});

function getRowKey(record: ReceivableManageItem, index?: number) {
  if (record?.isSummaryRow && record?.id) return String(record.id);
  // 优先 masterId；同一 key 可能多行时带下标保证唯一
  const base = record?.masterId || record?.id || 'row';
  return `${base}-${pagination.current}-${index ?? 0}`;
}

function getCustomRow(record: ReceivableManageItem) {
  return {
    class: record.isSummaryRow ? 'summary-row' : undefined,
  };
}

function updateTableScrollY() {
  const area = tableAreaRef.value;
  if (!area) {
    tableScrollY.value = undefined;
    tableAreaMaxHeight.value = undefined;
    return;
  }
  const listPanel = area.parentElement as HTMLElement | null;
  const toolbar = listPanel?.querySelector('.list-toolbar') as HTMLElement | null;
  const paginationEl = listPanel?.querySelector('.pagination-bar') as HTMLElement | null;
  const headerEl = area.querySelector('.ant-table-header') as HTMLElement | null;
  const headerH = headerEl?.offsetHeight || TABLE_HEADER_HEIGHT;

  const panelH = listPanel?.clientHeight || area.clientHeight;
  const toolbarH = toolbar?.offsetHeight || 0;
  const paginationH = paginationEl?.offsetHeight || 0;
  const maxAreaH = Math.max(0, panelH - toolbarH - paginationH);
  const available = Math.floor(maxAreaH - headerH);
  const summaryExtra = dataSource.value.some((row) => row.isSummaryRow) ? 1 : 0;
  const needed =
    (Math.max(1, pagination.pageSize) + summaryExtra) * TABLE_ROW_HEIGHT +
    TABLE_SCROLLBAR_SIZE;

  if (available <= 0) {
    tableScrollY.value = TABLE_BODY_FALLBACK;
    tableAreaMaxHeight.value = undefined;
    tableBodyYScroll.value = true;
    return;
  }

  tableScrollY.value = available;
  tableAreaMaxHeight.value = maxAreaH || undefined;
  // 搜索收起且空间够 → 无竖滚；搜索展开空间不够 → 表内竖滚（行高/字号不变）
  tableBodyYScroll.value = available < needed;
}

const rowSelection = computed<TableProps['rowSelection']>(() => ({
  selectedRowKeys: selectedRowKeys.value,
  fixed: true,
  getCheckboxProps: (record: ReceivableManageItem) => ({
    disabled: !!record.isSummaryRow,
    style: record.isSummaryRow ? { display: 'none' } : undefined,
  }),
  onChange: (keys: (string | number)[], rows: ReceivableManageItem[]) => {
    selectedRowKeys.value = keys
      .map(String)
      .filter((key) => key !== '__receivable_manage_summary__');
    selectedMasterIds.value = [
      ...new Set(
        (rows ?? [])
          .filter((row) => !row?.isSummaryRow)
          .map((row) => String(row?.masterId ?? '').trim())
          .filter(Boolean),
      ),
    ];
  },
}));

function blank(value?: string) {
  return (value ?? '').trim();
}

/** 未勾选导出时带给 createExportTask 的筛选条件 */
const exportQueryData = computed(() => {
  const data: Record<string, string | boolean> = {
    salesOfficeRegionCode: blank(searchForm.financeArea),
    saleOfficeCode: blank(searchForm.companyCode),
    sapCustomerCode: blank(searchForm.customerCode),
    financeCode: blank(searchForm.financeOwner),
    salesmanUserCode: blank(searchForm.salesman),
    dissaleChannelCode: blank(searchForm.dissaleChannelCode),
    feedbackStatus: '',
    riskLevel: blank(searchForm.riskLevel),
    controlUserCode: blank(searchForm.controlUserCode),
  };
  const hasControlUser = toOptionalBoolean(searchForm.hasControlUser);
  const isProsecute = toOptionalBoolean(searchForm.isProsecute);
  const isOverdue = toOptionalBoolean(searchForm.isOverdue);
  if (typeof hasControlUser === 'boolean') data.hasControlUser = hasControlUser;
  if (typeof isProsecute === 'boolean') data.isProsecute = isProsecute;
  if (typeof isOverdue === 'boolean') data.isOverdue = isOverdue;
  return data;
});

// ── 分公司下拉：搜索 + 滚动分页 ──────────────────────────────────────────

const OFFICE_PAGE_SIZE = 15;
const officeOptions = ref<{ value: string; label: string }[]>([]);
const officeFetching = ref(false);
const officeKeyword = ref('');
const officePage = ref(1);
const officeTotalPages = ref(1);
const officeHasMore = computed(() => officePage.value < officeTotalPages.value);
let officeSearchTimer: ReturnType<typeof setTimeout> | null = null;
let officeLoadingMore = false;

async function fetchOfficeOptions(reset: boolean) {
  if (officeFetching.value && !reset) return;
  if (!reset && (officeLoadingMore || !officeHasMore.value)) return;

  const nextPage = reset ? 1 : officePage.value + 1;
  officeFetching.value = true;
  if (!reset) officeLoadingMore = true;

  try {
    const pageData = await querySalesOfficePage({
      currentPage: nextPage,
      size: OFFICE_PAGE_SIZE,
      keyword: officeKeyword.value,
    });

    const mapped = (pageData.content ?? []).map((item) => ({
      value: item.code,
      label: item.name,
    }));

    officeOptions.value = reset
      ? mapped
      : mergeOfficeOptions(officeOptions.value, mapped);
    officePage.value = nextPage;
    officeTotalPages.value = Math.max(1, pageData.totalPages || 1);
  } catch (error) {
    if (reset) officeOptions.value = [];
    message.error(error instanceof Error ? error.message : '获取分公司失败');
  } finally {
    officeFetching.value = false;
    officeLoadingMore = false;
  }
}

function mergeOfficeOptions(
  prev: { value: string; label: string }[],
  next: { value: string; label: string }[],
) {
  const map = new Map(prev.map((item) => [item.value, item]));
  next.forEach((item) => map.set(item.value, item));
  return [...map.values()];
}

function onOfficeSearch(keyword: string) {
  officeKeyword.value = keyword;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
  officeSearchTimer = setTimeout(() => {
    fetchOfficeOptions(true);
  }, 300);
}

function onOfficePopupScroll(e: Event) {
  const target = e.target as HTMLElement;
  if (!target) return;
  const nearBottom = target.scrollTop + target.offsetHeight >= target.scrollHeight - 24;
  if (nearBottom) {
    fetchOfficeOptions(false);
  }
}

function onOfficeDropdownVisible(open: boolean) {
  if (open && officeOptions.value.length === 0) {
    officeKeyword.value = '';
    fetchOfficeOptions(true);
  }
}

// ── 列表 ────────────────────────────────────────────────────────────────

async function fetchList() {
  loading.value = true;
  // 先清空，避免请求期间仍展示上一批数据；成功后再重建表格清掉 fixed 残留
  dataSource.value = [];
  selectedRowKeys.value = [];
  selectedMasterIds.value = [];
  const filterParams = {
    salesOfficeRegionCode: searchForm.financeArea,
    saleOfficeCode: searchForm.companyCode,
    sapCustomerCode: searchForm.customerCode,
    financeCode: searchForm.financeOwner,
    salesmanUserCode: searchForm.salesman,
    dissaleChannelCode: searchForm.dissaleChannelCode,
    riskLevel: searchForm.riskLevel,
    controlUserCode: searchForm.controlUserCode,
    hasControlUser: toOptionalBoolean(searchForm.hasControlUser),
    isProsecute: toOptionalBoolean(searchForm.isProsecute),
    isOverdue: toOptionalBoolean(searchForm.isOverdue),
  };
  try {
    const pageData = await queryReceivableManagePage({
      currentPage: pagination.current,
      size: pagination.pageSize,
      ...filterParams,
    });

    let rows = pageData.content;
    if (rows.length > 0) {
      try {
        const summaryRow = await queryReceivableManageStatisticalData(filterParams);
        if (summaryRow) {
          rows = [summaryRow, ...rows];
        }
      } catch (statError) {
        message.warning(
          statError instanceof Error ? statError.message : '获取合计数据失败',
        );
      }
    }

    dataSource.value = rows;
    pagination.total = pageData.totalElements;
    tableRenderKey.value += 1;
    nextTick(() => {
      requestAnimationFrame(() => updateTableScrollY());
    });
  } catch (error) {
    dataSource.value = [];
    pagination.total = 0;
    tableRenderKey.value += 1;
    message.error(error instanceof Error ? error.message : '获取应收报表列表失败');
  } finally {
    loading.value = false;
  }
}

function handleSearch() {
  pagination.current = 1;
  fetchList();
}

function handleReset() {
  searchForm.financeArea = undefined;
  searchForm.companyCode = undefined;
  searchForm.financeOwner = '';
  searchForm.customerCode = '';
  searchForm.salesman = '';
  searchForm.dissaleChannelCode = undefined;
  searchForm.riskLevel = undefined;
  searchForm.controlUserCode = '';
  searchForm.hasControlUser = undefined;
  searchForm.isProsecute = undefined;
  searchForm.isOverdue = undefined;
  selectedRowKeys.value = [];
  selectedMasterIds.value = [];
  pagination.current = 1;
  fetchList();
}

function onPaginationChange(page: number, pageSize: number) {
  const sizeChanged = pageSize !== pagination.pageSize;
  pagination.current = sizeChanged ? 1 : page;
  pagination.pageSize = pageSize;
  fetchList();
}

const exportVisible = ref(false);

function handleExport() {
  exportVisible.value = true;
}

const importVisible = ref(false);

function handleImport() {
  importVisible.value = true;
}

const toolbarAuth = reactive<ReceivableManageToolbarAuth>({
  canExport: false,
  canImport: false,
  canSendSummary: false,
  canSendBranch: false,
});

async function loadToolbarAuth() {
  const auth = await queryReceivableManageToolbarAuth();
  toolbarAuth.canExport = auth.canExport;
  toolbarAuth.canImport = auth.canImport;
  toolbarAuth.canSendSummary = auth.canSendSummary;
  toolbarAuth.canSendBranch = auth.canSendBranch;
}

const sendMailVisible = ref(false);
const sendMailDialogType = ref<'summary' | 'branch'>('summary');

function handleSendSummaryMail() {
  sendMailDialogType.value = 'summary';
  sendMailVisible.value = true;
}

function handleSendBranchMail() {
  sendMailDialogType.value = 'branch';
  sendMailVisible.value = true;
}

const editVisible = ref(false);
const editRecord = ref<ReceivableManageItem | null>(null);
const logVisible = ref(false);
const logRecord = ref<ReceivableManageItem | null>(null);

function handleEdit(record: ReceivableManageItem) {
  editRecord.value = record;
  editVisible.value = true;
}

function handleViewLog(record: ReceivableManageItem) {
  logRecord.value = record;
  logVisible.value = true;
}

let tableAreaRo: ResizeObserver | null = null;

onMounted(() => {
  loadToolbarAuth();
  fetchList();
  window.addEventListener('resize', updateTableScrollY);

  requestAnimationFrame(() => {
    updateTableScrollY();
    if (tableAreaRef.value && typeof ResizeObserver !== 'undefined') {
      tableAreaRo = new ResizeObserver(() => updateTableScrollY());
      tableAreaRo.observe(tableAreaRef.value);
    }
    requestAnimationFrame(() => updateTableScrollY());
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', updateTableScrollY);
  tableAreaRo?.disconnect();
  tableAreaRo = null;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["search-bar", { collapsed: !searchExpanded.value }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["search-bar-body", { expanded: searchExpanded.value }])
        }, [
          _createVNode(_component_a_form, {
            layout: "horizontal",
            colon: false,
            model: searchForm,
            class: "search-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [12, 12] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "财务大区" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.financeArea,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.financeArea) = $event)),
                            "allow-clear": "",
                            placeholder: "全部",
                            options: financeAreaOptions
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "分公司" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.companyCode,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.companyCode) = $event)),
                            "show-search": "",
                            "allow-clear": "",
                            placeholder: "输入编码或名称搜索",
                            "filter-option": false,
                            options: officeOptions.value,
                            "not-found-content": officeFetching.value ? undefined : null,
                            onSearch: onOfficeSearch,
                            onPopupScroll: onOfficePopupScroll,
                            onDropdownVisibleChange: onOfficeDropdownVisible
                          }, _createSlots({ _: 2 }, [
                            (officeFetching.value)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "options", "not-found-content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: searchColSpan }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "客户" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: searchForm.customerCode,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.customerCode) = $event)),
                            "allow-clear": "",
                            placeholder: "输入客户编码或名称",
                            onPressEnter: handleSearch
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (searchExpanded.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "分支财务" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.financeOwner,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.financeOwner) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "业务员" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.salesman,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchForm.salesman) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入工号或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "渠道" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.dissaleChannelCode,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchForm.dissaleChannelCode) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: channelOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "风险等级" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.riskLevel,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchForm.riskLevel) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: riskLevelOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "同一控制人" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: searchForm.controlUserCode,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchForm.controlUserCode) = $event)),
                                  "allow-clear": "",
                                  placeholder: "输入编码或名称",
                                  onPressEnter: handleSearch
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否有同一控制人" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.hasControlUser,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchForm.hasControlUser) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否起诉客户" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.isProsecute,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((searchForm.isProsecute) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: searchColSpan }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "是否逾期" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: searchForm.isOverdue,
                                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchForm.isOverdue) = $event)),
                                  "allow-clear": "",
                                  placeholder: "全部",
                                  options: yesNoOptions
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { onClick: handleReset }, {
              default: _withCtx(() => [
                _createTextVNode("重置")
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              class: "expand-toggle",
              onClick: toggleSearchExpand
            }, [
              _createTextVNode(_toDisplayString(searchExpanded.value ? '收起' : '展开') + " ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(searchExpanded.value ? '▲' : '▼'), 1)
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (toolbarAuth.canExport)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: handleExport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("导出")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (toolbarAuth.canImport)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: handleImport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("导入")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (toolbarAuth.canSendSummary)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: "primary",
                    onClick: handleSendSummaryMail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 按汇总发邮件 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (toolbarAuth.canSendBranch)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    type: "primary",
                    onClick: handleSendBranchMail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 按分公司发邮件 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          ref_key: "tableAreaRef",
          ref: tableAreaRef,
          class: "table-area",
          style: _normalizeStyle(_unref(tableAreaStyle))
        }, [
          (_openBlock(), _createBlock(_component_a_table, {
            key: tableRenderKey.value,
            class: _normalizeClass(["receivable-table", { 'is-y-scroll': tableBodyYScroll.value }]),
            columns: _unref(columns),
            "data-source": dataSource.value,
            loading: loading.value,
            pagination: false,
            scroll: _unref(tableScroll),
            "row-selection": _unref(rowSelection),
            bordered: true,
            "row-key": getRowKey,
            "custom-row": getCustomRow,
            size: "small",
            onResizeColumn: _unref(handleResizeColumn)
          }, {
            bodyCell: _withCtx(({ column, record, text }) => [
              (record.isSummaryRow)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (column.key === 'action')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "合计"))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(text ?? ''), 1)
                        ], 64))
                  ], 64))
                : (column.key === 'action')
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 1,
                      size: 12,
                      class: "action-btns"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          size: "small",
                          onClick: ($event: any) => (handleEdit(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_button, {
                          type: "link",
                          size: "small",
                          onClick: ($event: any) => (handleViewLog(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 查看日志 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : (column.key === 'riskLevel')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["risk-cell", {
                    'risk-level-fill-high': record.riskLevel === '高',
                    'risk-level-fill-mid': record.riskLevel === '中',
                  }])
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(record.riskLevel || '-'), 1),
                        (record.riskManualModified)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "人工改"))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (column.key === 'riskReason')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "risk-cell-text",
                            title: record.riskReason || ''
                          }, _toDisplayString(record.riskReason || '-'), 9, _hoisted_12),
                          (record.riskManualModified)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "人工改"))
                            : _createCommentVNode("", true)
                        ]))
                      : (column.key === 'overdueReason')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _createElementVNode("span", {
                              class: "risk-cell-text",
                              title: record.overdueReason || ''
                            }, _toDisplayString(record.overdueReason || '-'), 9, _hoisted_15),
                            (record.riskManualModified)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "人工改"))
                              : _createCommentVNode("", true)
                          ]))
                        : (column.key === 'latestFeedback')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 5,
                              class: "risk-cell-text",
                              title: record.latestFeedback || ''
                            }, _toDisplayString(record.latestFeedback || '-'), 9, _hoisted_17))
                          : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "columns", "data-source", "loading", "scroll", "row-selection", "onResizeColumn"]))
        ], 4),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(pagination.total) + " 条", 1),
          _createVNode(_component_a_pagination, {
            current: pagination.current,
            "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((pagination.current) = $event)),
            pageSize: pagination.pageSize,
            "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((pagination.pageSize) = $event)),
            total: pagination.total,
            "show-size-changer": true,
            "show-quick-jumper": true,
            "page-size-options": pageSizeOptions,
            locale: _unref(paginationLocale),
            onChange: onPaginationChange
          }, null, 8, ["current", "pageSize", "total", "locale"])
        ])
      ])
    ]),
    _createVNode(EditRiskDialog, {
      visible: editVisible.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((editVisible).value = $event)),
      record: editRecord.value,
      onSubmitted: fetchList
    }, null, 8, ["visible", "record"]),
    _createVNode(ViewRiskLogDialog, {
      visible: logVisible.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((logVisible).value = $event)),
      record: logRecord.value
    }, null, 8, ["visible", "record"]),
    _createVNode(SendMailDialog, {
      visible: sendMailVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((sendMailVisible).value = $event)),
      "dialog-type": sendMailDialogType.value
    }, null, 8, ["visible", "dialog-type"]),
    _createVNode(ExportDialog, {
      visible: exportVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((exportVisible).value = $event)),
      "master-id-list": selectedMasterIds.value,
      "query-data": _unref(exportQueryData),
      path: _unref(RECEIVABLE_MANAGE_EXPORT_PATH)
    }, null, 8, ["visible", "master-id-list", "query-data", "path"]),
    _createVNode(ImportDialog, {
      visible: importVisible.value,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((importVisible).value = $event)),
      "master-id-list": selectedMasterIds.value,
      "query-data": _unref(exportQueryData),
      path: _unref(RECEIVABLE_MANAGE_IMPORT_PATH),
      onSuccess: fetchList
    }, null, 8, ["visible", "master-id-list", "query-data", "path"])
  ]))
}
}

})